import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import * as FileSaver from "file-saver";
import { TableModule } from "primeng/table";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { CommonModule } from "@angular/common";
import { OrderBillingStatus } from "../../../../core/models/dashboard/orderBillingStatus";
import { LoaderService } from "../../../../core/services/loader.service";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { SamplepoListingComponent } from "../../../samplePo/components/samplepo-listing/samplepo-listing.component";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";

@Component({
  selector: "jni-qr4-complete",
  templateUrl: "./qr4-complete.component.html",
  styleUrls: ["./qr4-complete.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DateFilterComponent,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
    SamplepoListingComponent,
    InputTextModule,
    ButtonModule,
    CardModule,
  ],
})
export class Qr4CompleteComponent implements OnInit, OnDestroy {
  qr4List: OrderBillingStatus[] = [];
  filterQr4List: OrderBillingStatus[] = [];
  orderDisplayModal = false;
  clientDisplayModal = false;
  samplePODisplayModal = false;
  clientId = "";
  saleOrderId = "";
  ponumber = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  inHandsDateColumn = "inHandsDate";

  constructor(
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.getQR2Reports();
  }

  onClose() {
    this.closeEvent.emit();
  }

  getQR2Reports() {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getOpenOrdersByInHandsDate(0).subscribe({
      next: res => {
        this.qr4List = res.data;
        this.filterQr4List = this.qr4List;
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  // onInHandDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.qr4List.filter((x) =>
  //       x.inHandsDate?.includes(event.target.value)
  //     );
  //     this.filterQr4List = filterList;
  //   } else {
  //     this.filterQr4List = this.qr4List;
  //   }
  // }

  redirectToClientSummary(customerAccountNumber: string) {
    // this._router.navigate([
    //   'clients/active/client-details/' + customerAccountNumber
    // ]);
    if (customerAccountNumber) {
      this.clientId = customerAccountNumber;
      this.clientDisplayModal = true;
    }
  }

  redirectToSummary(saleOrderId: string) {
    //this._router.navigate(['orders/order-summary/' + saleOrderId]);
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  redirectToSamplePO(orderNumber: string, purchaseOrderNumber: string) {
    if (purchaseOrderNumber) {
      if (orderNumber) {
        // this._router.navigateByUrl('/samplepo', {
        //   state: orderNumber
        // });
        this.ponumber = orderNumber;
        this.samplePODisplayModal = true;
      }
      //this._router.navigate(['samplepo/samplepo-summary/' + poNumber]);
    }
  }

  exportQuadReport4() {
    this.exportExcelForFilterData(this.qr4List);
  }

  exportExcelForFilterData(filterclientlist: OrderBillingStatus[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["In Hands Date"]: new Date(datum.inHandsDate),
        ["Order #"]: datum.orderNumber,
        ["Client"]: datum.clientName,
        ["Job Name"]: datum.jobName,
        ["% Cost In"]: datum.costIn,
        ["Pre-Bill/Inv"]: datum.preBillInv,
        ["Split"]: datum.split,
        ["Total Merch"]: datum.totalMerch,
        ["Status"]: datum.salesStatus,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Open orders by In Hands Date");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModalForSamplePO() {
    this.samplePODisplayModal = false;
  }

  addScollHiddenClass() {
    this.renderer.addClass(document.body, "p-overflow-hidden");
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  applyFilter($event: OrderBillingStatus[] | DateFilter) {
    if (Array.isArray($event)) {
      this.filterQr4List = $event;
    }
  }

  clearFilter($event: OrderBillingStatus[] | DateFilter) {
    if (Array.isArray($event)) {
      this.filterQr4List = $event;
    }
  }
}
